exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mb55 {\n  margin-bottom: 6em;\n}\n@media screen and (min-width: 80em) {\n.mb55 {\n  margin-bottom: 0;\n}\n.grid-dashboard {\n  display: grid;\n  grid-template-rows: 51px 1fr;\n  grid-template-columns: 221px 1fr;\n  grid-template-areas:\n    \"nav nav\"\n    \"side main\"\n}\n.grid-modified {\n  display: grid;\n  grid-template-rows: none;\n  grid-template-columns: 221px 1fr;\n  grid-template-areas:\n    \"nav nav\"\n    \"side main\"\n}\n.pt0-xl {\n  padding-top: 0;\n}\n}\n.max-w {\n  max-width: 70rem;\n}\n.grid-main {\n  grid-area: main;\n}\n@media (max-width: 1400px) {\n.max-w {\n  max-width: 65rem;\n}\n}\n@media (max-width: 1330px) {\n.max-w {\n  max-width: 62rem;\n}\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5d83d9ca","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/AppBase.vue
// module id = 1400
// module chunks = 0